import { Routes, Route, Navigate } from "react-router-dom";
import StoreLayout from "../layout/StoreLayout";
import StoreInicio from "../pages/store/StoreInicio";
import StoreHome from "../pages/store/StoreHome";
import ProductoDetalles from "../pages/store/ProductoDetalles";
import Cart from "../pages/store/page/Cart";
import Favoritos from "../pages/store/Favoritos";
import CheckoutDatos from "../pages/store/page/checkout/CheckoutDatos";
import CheckoutMetodoEnvio from "../pages/store/page/checkout/CheckoutMetodoEnvio";
import CheckoutPago from "../pages/store/page/checkout/CheckoutPago";
import CheckoutSuccess from "../pages/store/page/CheckoutSuccess";
import CheckoutPayment from "../pages/store/page/CheckoutPayment";
import CheckoutPending from "../pages/store/page/CheckoutPending";
import LegalDocumentPage from "../pages/store/PaginaDocumentosLegales";
import ErrorTienda from "../pages/store/errortienda";

function StoreRoutes() {
  return (
    <Routes>
      <Route element={<StoreLayout />}>
        <Route index element={<Navigate to="inicio" replace />} />
        <Route path="inicio" element={<StoreInicio />} />
        <Route path="productos" element={<StoreHome />} />
        <Route path="ofertas" element={<Navigate to="/store/productos" replace />} />
        <Route path="product/:id" element={<ProductoDetalles />} />
        <Route path="cart" element={<Cart />} />
        <Route path="favoritos" element={<Favoritos />} />
        <Route path="checkout/datos" element={<CheckoutDatos />} />
        <Route path="checkout/metodo-envio" element={<CheckoutMetodoEnvio />} />
        <Route path="checkout/pago/:grupo_reserva" element={<CheckoutPago />} />
        <Route path="checkout/payment/:grupo_reserva" element={<CheckoutPayment />} />
        <Route path="checkout/success" element={<CheckoutSuccess />} />
        <Route
          path="checkout/pending/:grupo_reserva"
          element={<CheckoutPending />}
        />
        <Route path="legal/:slug" element={<LegalDocumentPage />} />
      </Route>
      <Route path="errortienda" element={<ErrorTienda />} />
    </Routes>
  );
}

export default StoreRoutes;
